import apis from "../../utils/apis";
import { FETCH_ALL_LAWYERS } from "../types";
import { handleApiError } from "./utils/utils";

interface FetchLawyersParams {
  searchTerm?: string;
  filters?: { [key: string]: string[] };
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  pageSize?: number;
}

export const fetchAllLawyers = (params: FetchLawyersParams = {}) => {
  return async (dispatch: any) => {
    try {
      const {
        searchTerm = "",
        filters = {},
        sortBy = "name",
        sortOrder = "asc",
        page = 1,
        pageSize = 12,
      } = params;
      const filtersJson = JSON.stringify(filters);

      const resp = await apis({
        method: "GET",
        url: "/user/lawyers/list",
        params: { searchTerm, filters: filtersJson, sortBy, sortOrder, page, pageSize },
      });

      if (resp && resp.status === 200) {
        const { lawyers, currentPage, total_lawyers, hasMore } = resp.data;
        dispatch({ type: FETCH_ALL_LAWYERS, payload: lawyers });
        return { payload: { lawyers, currentPage, total_lawyers, hasMore } };
      } else {
        handleApiError(resp, dispatch);
      }
    } catch (err: any) {
      handleApiError(err, dispatch);
    }
    return false;
  };
};

export const removeLawyer = (lawyerId: string) => {
  return async (dispatch: any): Promise<boolean> => {
    try {
      const resp = await apis({
        method: "POST",
        url: "/user/lawyers/remove",
        data: { LawyerID: lawyerId },
      });

      if (resp && resp.status === 200) {
        dispatch(fetchAllLawyers());
        return true;
      } else {
        handleApiError(resp, dispatch);
      }
    } catch (err: any) {
      handleApiError(err, dispatch);
    }
    return false;
  };
};

export const fetchLawyerInformation = (lawyerId: string) => {
  return async (dispatch: any) => {
    try {
      const resp = await apis.post('/user/lawyers/get_information', { LawyerID: lawyerId });
      if (resp.status === 200) {
        return resp.data.lawyer;
      } else {
        handleApiError(resp, dispatch);
      }
    } catch (err: any) {
      handleApiError(err, dispatch);
    }
    return null;
  };
};

export const fetchLawyerCases = (lawyerId: string) => {
  return async (dispatch: any) => {
    try {
      const resp = await apis.post('/lawyers/get_cases', { LawyerID: lawyerId });
      if (resp.status === 200) {
        return resp.data.cases || [];
      } else {
        handleApiError(resp, dispatch);
      }
    } catch (err: any) {
      handleApiError(err, dispatch);
    }
    return [];
  };
};

export const fetchLawyerEngagementTerms = (lawyerId: string) => {
  return async (dispatch: any) => {
    try {
      const resp = await apis.get('/engagement_letter/get', { params: { client_id: lawyerId } });
      if (resp.status === 200) {
        return resp.data;
      } else {
        handleApiError(resp, dispatch);
      }
    } catch (err: any) {
      handleApiError(err, dispatch);
    }
    return null;
  };
};

export const fetchLawyerDocuments = (lawyerId: string) => {
  return async (dispatch: any) => {
    try {
      const resp = await apis.post('/user/lawyers/get_documents', { LawyerID: lawyerId });
      if (resp.status === 200) {
        return resp.data.documents || [];
      } else {
        handleApiError(resp, dispatch);
      }
    } catch (err: any) {
      handleApiError(err, dispatch);
    }
    return [];
  };
};

export const fetchLawyerBilling = (lawyerId: string) => {
  return async (dispatch: any) => {
    try {
      const resp = await apis.post('/user/lawyers/get_billing', { LawyerID: lawyerId });
      if (resp.status === 200) {
        return resp.data.billing || {};
      } else {
        handleApiError(resp, dispatch);
      }
    } catch (err: any) {
      handleApiError(err, dispatch);
    }
    return {};
  };
};